<template>
  <section class="app-article-detail">
    <h1 class="app-article-detail-title">{{ articleDetail?.title }}</h1>
    <article
      class="app-article-detail-content app-markdown-content"
      v-html="articleDetail?.content_html"
      @click="handleImagePreview"
    />
    <div class="mt-6 flex justify-end"><CommonBackToTop /></div>
    <BaseImagePreview :src="imagePreviewSrc" :alt="imagePreviewAlt" v-model:visible="imagePreview" />
  </section>
</template>
<script setup lang="ts">
const route = useRoute()
const { fetchArticleDetail } = useArticleStore()
const articleDetail = await fetchArticleDetail(Number(route.params.id))
const imagePreview = ref(false)
const imagePreviewSrc = ref('')
const imagePreviewAlt = ref('')
const handleImagePreview = (e: MouseEvent) => {
  const target = e.target as HTMLElement
  if (target.tagName === 'IMG') {
    imagePreviewSrc.value = target.getAttribute('src') || ''
    imagePreviewAlt.value = target.getAttribute('alt') || ''
    imagePreview.value = true
  }
}
</script>
<style lang="scss">
@import '@/assets/css/markdown-theme.scss';
</style>
<style lang="scss" scoped>
.app-article-detail {
  @apply w-full ltr:pl-17.5 rtl:pr-17.5 ltr:pr-17 rtl:pl-17 pb-16;
}
.app-article-detail-title {
  @apply relative ltr:pl-5 rtl:pr-5 text-[34px] font-bold leading-[46px];
  @apply before:absolute ltr:before:left-0 rtl:before:right-0 before:top-3 before:h-6 before:w-1.5 before:bg-primary before:content-[''];
}
</style>
